var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticClass: "tab-content" }, [
      _c("div", { staticClass: "tab-content__skill" }, [
        _c(
          "div",
          {
            staticClass: "align-items-center",
            class: _vm.showSkillLevel ? "mb20" : "mb16",
          },
          [
            _c(
              "span",
              {
                staticClass: "title ellipsis",
                class: {
                  space:
                    _vm.activeSkillItem.name &&
                    _vm.activeSkillItem.name.length > 140,
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.activeSkillItem.name) +
                    "\n        "
                ),
              ]
            ),
          ]
        ),
        _vm.showSkillLevel
          ? _c("div", {
              staticClass: "info",
              domProps: {
                textContent: _vm._s(_vm.activeSkillItem.description),
              },
            })
          : _c("div", { staticClass: "no-skill-container" }, [
              _c("div", { staticClass: "mb16" }, [
                _c("div", { staticClass: "label mb8" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("pc_gwnl_global_lbl_skillDescription")) +
                      "\n          "
                  ),
                ]),
                _c("div", {
                  staticClass: "info",
                  domProps: {
                    textContent: _vm._s(_vm.activeSkillItem.description),
                  },
                }),
              ]),
              _vm.activeSkillItem.behavior
                ? _c("div", [
                    _c("div", { staticClass: "label mb8" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("pc_gwnl_global_lbl_behavior")) +
                          "\n          "
                      ),
                    ]),
                    _c("div", {
                      staticClass: "info",
                      domProps: {
                        textContent: _vm._s(_vm.activeSkillItem.behavior),
                      },
                    }),
                  ])
                : _vm._e(),
            ]),
      ]),
      _vm.activeSkillItem &&
      _vm.activeSkillItem.levelList &&
      _vm.activeSkillItem.levelList.length > 0 &&
      _vm.showSkillLevel
        ? _c(
            "div",
            { staticClass: "pt32 border-top-gray-4" },
            _vm._l(_vm.formatSkillItem || [], function (item, index) {
              return _c(
                "div",
                { key: index },
                [_c("skill-level", { attrs: { item: item } })],
                1
              )
            }),
            0
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }